import React from 'react';

import { FeatureFlags } from '~/stores/use-feature-flags/feature-flags.types';
import { useFeatureFlags } from '~/stores/use-feature-flags/useFeatureFlags';

interface RenderFeatureFlagProps {
  requiredFlag: FeatureFlags;
  children?: React.ReactNode;
}

export const RenderFeatureFlag = ({
  requiredFlag,
  children,
}: RenderFeatureFlagProps) => {
  const flags = useFeatureFlags(state => state.flags);

  if (!flags[requiredFlag]) {
    return null;
  }

  return <>{children}</>;
};
